import { m } from "@vega-core/paraglide/messages";
import { TrackingTag } from "@vega-modules/scenes/CoInvestmentsGP/components/TrackingTable/components/TrackingTag";
import { areAllNdasSigned } from "@vega-modules/scenes/CoInvestmentsGP/components/TrackingTable/utils/ndaHelpers";

type NdaStatusBadgeProps = {
  numberOfNdasSigned: number;
  numberOfNdasIssued: number;
  dataTestId?: string;
};

export function NdaStatusBadge({
  numberOfNdasSigned,
  numberOfNdasIssued,
  dataTestId,
}: NdaStatusBadgeProps) {
  if (numberOfNdasIssued === 0) return null;

  const variant = areAllNdasSigned({ numberOfNdasSigned, numberOfNdasIssued })
    ? "positive"
    : "pending";

  return (
    <TrackingTag
      dataTestId={dataTestId}
      title={m.coInvestments_dataRoom_ndaStatus({
        signed: numberOfNdasSigned,
        issued: numberOfNdasIssued,
      })}
      variant={variant}
    >
      {`${m.common_signed()} ${numberOfNdasSigned}/${numberOfNdasIssued}`}
    </TrackingTag>
  );
}
